import { render } from "./QueTips.vue?vue&type=template&id=299299f2"
import script from "./QueTips.vue?vue&type=script&lang=js"
export * from "./QueTips.vue?vue&type=script&lang=js"

import "./QueTips.vue?vue&type=style&index=0&id=299299f2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__